/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef,useEffect } from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'

export default function Model({ ...props }) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('/MassageGun/gunHead2.glb')
  const { actions } = useAnimations(animations, group)
  useEffect(() => {
    actions.Animation5.play();
    actions.Animation5.repetitions = 1;
    actions.Animation5.clampWhenFinished = true;
  }, [actions]);
  return (
    <group ref={group} {...props} dispose={null}>
      <group>
        <group name="head2" position={[0.6, 0, 0]} rotation={[0, 0, 1.2]}>
          <mesh geometry={nodes.圓柱體.geometry} material={materials['材質.006']} />
          <mesh geometry={nodes.圓柱體_1.geometry} material={materials['材質.005']} />
        </group>
      </group>
    </group>
  )
}

useGLTF.preload('/MassageGun/gunHead2.glb')
